export const STATUS_LABELS = {
  new: "Yeni",
  preparing: "Hazırlanıyor",
  ready: "Hazır",
  notified: "Bildirim Gönderildi",
  delivered: "Teslim Edildi",
  cancelled: "İptal",
};

export const STATUS_ORDER = ["new", "preparing", "ready", "notified", "delivered", "cancelled"];

export const STATUS_STYLES = {
  new: "bg-blue-500/15 border-blue-500/40 text-blue-500",
  preparing: "bg-amber-500/15 border-amber-500/40 text-amber-600",
  ready: "bg-emerald-500/20 border-emerald-500/50 text-emerald-600 font-bold",
  notified: "bg-cyan-500/15 border-cyan-500/40 text-cyan-600",
  delivered: "bg-slate-500/20 border-slate-500/40 text-slate-500",
  cancelled: "bg-rose-500/15 border-rose-500/40 text-rose-500",
};

export const STATUS_STYLES_DARK = {
  new: "bg-blue-500/15 border-blue-500/40 text-blue-300",
  preparing: "bg-amber-500/15 border-amber-500/40 text-amber-300",
  ready: "bg-emerald-500/20 border-emerald-500/60 text-emerald-300 font-bold",
  notified: "bg-cyan-500/15 border-cyan-500/40 text-cyan-300",
  delivered: "bg-slate-500/20 border-slate-500/40 text-slate-300",
  cancelled: "bg-rose-500/15 border-rose-500/40 text-rose-300",
};

export const UNITS = ["Litre", "Kg", "Ton", "Varil", "IBC", "Adet"];
export const PRODUCT_CATEGORIES = ["Alkali", "Asidik", "Genel Temizlik", "Solvent", "Sarf Malzeme", "Yağ Grubu"];
export const SHIPPING_TYPES = ["Şirket Aracı", "Kendi Aracı", "Ambar", "Kargo", "Kendisi Alacak"];

export const WA_STATUS_LABELS = {
  pending: "Bekliyor",
  sending: "Gönderiliyor",
  success: "E-posta Gönderildi",
  failed: "E-posta Başarısız",
  not_applicable: "E-posta Yok",
};

export function orderItems(order) {
  if (order?.items?.length) return order.items;
  if (order?.product_snapshot)
    return [{
      product_code: order.product_snapshot.product_code,
      product_name: order.product_snapshot.product_name,
      quantity: order.quantity,
      unit: order.unit || order.product_snapshot.unit,
    }];
  return [];
}

export function itemsSummary(order) {
  const items = orderItems(order);
  const byUnit = {};
  items.forEach((it) => {
    const u = it.unit || "";
    byUnit[u] = (byUnit[u] || 0) + (parseFloat(it.quantity) || 0);
  });
  const totals = Object.entries(byUnit).map(([u, q]) => `${q} ${u}`).join(", ");
  return { count: items.length, totals };
}

export const ROLE_LABELS = {
  admin: "Yönetici",
  staff: "Sipariş Personeli",
  production: "Üretim",
};

export function isOverdue(order) {
  if (!["new", "preparing", "ready", "notified"].includes(order?.status)) return false;
  if (!order?.delivery_date) return false;
  const d = new Date(`${order.delivery_date}T23:59:59`);
  if (isNaN(d.getTime())) return false;
  return d.getTime() < Date.now();
}


export const PAGES = [
  { key: "order_entry", label: "Sipariş Girişi", path: "/" },
  { key: "orders", label: "Siparişler", path: "/orders" },
  { key: "kiosk", label: "Üretim Panosu", path: "/kiosk" },
  { key: "dashboard", label: "Yönetim Paneli", path: "/dashboard" },
  { key: "management", label: "Müşteri & Ürün", path: "/management" },
  { key: "audit", label: "İşlem Günlüğü", path: "/audit" },
];


// Sevk formu (dispatch note) üstbilgisinde kullanılan gönderen firma bilgileri.
// Firmanıza göre buradan güncelleyebilirsiniz.
export const COMPANY = {
  name: "BİOKİMSAN PETROL KİMYA SAN. TİC. LTD. ŞTİ.",
  address: "Aladdinbey Mah. Atilla Tatveren Cad. No:28, Nilüfer / BURSA 16140",
  phone: "0534 056 06 03",
  email: "info@bursankimya.com",
};
